import {IncomingMessage, ServerResponse} from 'http';
import {IStateViewer} from './reducer';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../common/util/redux';
import {
  IViewerContent,
  IViewerDecryptInfo,
  IViewerEpisode,
  IViewerImage,
  IViewerState,
} from '../type';

export enum ActionType {
  SetValue = 'viewer.SetValue',
  SetPropertyValues = 'viewer.SetPropertyValues',
  FetchViewerEpisode = 'viewer.FetchViewerEpisode',
  FetchViewerMeta = 'viewer.FetchViewerMeta',
  FetchResources = 'viewer.FetchFetchResources',
  SetResources = 'viewer.SetResources',
  FetchViewerData = 'viewer.FetchViewerData',
  SetViewerData = 'viewer.SetViewerData',
  SetViewerState = 'viewer.SetViewerState',
  InitViewerState = 'viewer.InitViewerState',
  FetchLikeEpisode = 'viewer.FetchLikeEpisode',
  OnFetchImageFinished = 'viewer.OnFetchImageFinished',
  SetImageUrl = 'viewer.SetImageUrl',
  SetViewerContentAndEpisode = 'viewer.SetViewerContentAndEpisode',
}

export const actions = {
  ...createBasicActions<IStateViewer>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  setViewerState: (viewerState: IViewerState) =>
    createAction(ActionType.SetViewerState, {viewerState}),
  initViewerState: () => createAction(ActionType.InitViewerState),
  fetchViewerEpisode: (payload: {
    episodeId: number;
    sid: string;
    res?: ServerResponse;
    req?: IncomingMessage;
  }) =>
    createActionFetch(ActionType.FetchViewerEpisode, {
      payload,
      fetchKey: payload.episodeId,
    }),
  fetchResources: (payload: {
    episodeId: number;
    contentId: number;
    initialPage: number;
  }) =>
    createActionFetch(ActionType.FetchResources, {
      payload,
      fetchKey: payload.episodeId,
    }),
  setResources: (data: {
    decryptInfo: IViewerDecryptInfo;
    images: IViewerImage[];
  }) => createAction(ActionType.SetResources, data),
  fetchViewerData: (contentId: number, episodeId: number) =>
    createActionFetch(ActionType.FetchViewerData, {
      payload: {contentId, episodeId},
      fetchKey: episodeId,
    }),
  setViewerData: (
    data: Pick<
      IStateViewer,
      'prevEpisode' | 'nextEpisode' | 'viewerEnd' | 'curEpisodeOffset'
    >
  ) => createAction(ActionType.SetViewerData, data),
  onFetchImageFinished: () => createAction(ActionType.OnFetchImageFinished),
  setImageUrl: (data: {index: number; url: string; episodeId: number}) =>
    createAction(ActionType.SetImageUrl, data),
  fetchLikeEpisode: (payload: {
    contentId: number;
    episodeId: number;
    likeCount: number;
    rollbackCount: number;
  }) =>
    createActionFetch(ActionType.FetchLikeEpisode, {
      payload,
      fetchKey: payload.episodeId,
    }),
  setViewerContentAndEpisode: (
    content: IViewerContent,
    episode: IViewerEpisode
  ) => createAction(ActionType.SetViewerContentAndEpisode, {content, episode}),
};
